import React from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
  Badge,
} from "antd";

import { ReactComponent as Visa } from "../assets/images/visa.svg";
import { ReactComponent as Hotel } from "../assets/images/hotel.svg";
import { ReactComponent as BreakFast } from "../assets/images/breakFast.svg";
import { ReactComponent as Transport } from "../assets/images/transport.svg";
import { Input } from "antd";
import activitiesImg from "../assets/images/activities.jpg";
import crazyDealImg from "../assets/images/crazyDeals.jpg";
import hotelImg from "../assets/images/hotel.jpg";
import holidayImg from "../assets/images/holiday.jpg";
import visaImg from "../assets/images/visa.jpg";
import cruiseImg from "../assets/images/cruise.jpg";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import exploreCountryImg from "../assets/images/ex-country-1.jpg";
import exploreCountryTwoImg from "../assets/images/ex-country-2.jpg";
import exploreCountryThreeImg from "../assets/images/ex-country-3.jpg";
import sliderImg from "../assets/images/bannerHotel.jpg";
import { ReactComponent as CheckOutlinedCustom } from "../assets/images/checkbox-icon.svg";
import { ReactComponent as Accommodation } from "../assets/images/accommodation.svg";
import { ReactComponent as AllMeals } from "../assets/images/all-meals.svg";
import { ReactComponent as OnTourTransport } from "../assets/images/On-tour transport.svg";
import { ReactComponent as BestValueItinerary } from "../assets/images/best-value-itinerary.svg";
import { ReactComponent as TourManagers } from "../assets/images/tour-managers.svg";
import cruiseIcon from "../assets/images/cruiseIcon.svg";
import cruiseImgOne from "../assets/images/cruise1.jpg";
import cruiseImgTwo from "../assets/images/cruise2.jpg";
import cruiseImgThree from "../assets/images/cruise3.jpg";

import {
  GiftOutlined,
  DollarOutlined,
  HomeOutlined,
  CompassOutlined,
  FileDoneOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import MegaMenu from "../components/MegaMenu";
import HotelSearchForm from "../components/HotelSearchForm";
import HotelSearchUI from "../components/HotelSearchForm";
import ExplorePlaces from "../components/ExplorePlaces";
import ReviewSlider from "../components/ReviewSlider";
import CruiseSearch from "../components/CruiseSearch";
import ExploreAttractions from "../components/ExploreAttractions";

const { Text, Paragraph } = Typography;
const categories = [
  {
    title: "Activities",
    desc: "your wanderlust awaits!",
    icon: <GiftOutlined />,
    img: activitiesImg,
  },
  {
    title: "Crazy Deals",
    desc: "Deal on Hotel and Flights",
    icon: <DollarOutlined />,
    img: crazyDealImg,
  },
  {
    title: "Hotel",
    desc: "your wanderlust awaits!",
    icon: <HomeOutlined />,
    img: hotelImg,
  },
  {
    title: "Holiday",
    desc: "your wanderlust awaits!",
    icon: <CompassOutlined />,
    img: holidayImg,
  },
  {
    title: "Visa",
    desc: "your wanderlust awaits!",
    icon: <FileDoneOutlined />,
    img: visaImg,
  },
  {
    title: "Cruise",
    desc: "your wanderlust awaits!",
    icon: <RocketOutlined />,
    img: cruiseImg,
  },
];

const offers = [
  {
    img: cruiseImgOne,
    title: "Balcony Bonus",
    desc: "Get up to $200 extra to spend at sea on",
    note: "*balconies & suites",
  },
  {
    img: cruiseImgTwo,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: cruiseImgThree,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
];

const tours = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
];

const cruisePack = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
  {
    id: 4,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
];

const highlights = [
  "Singapore and Bali Honeymoon Bliss | City Romance to Tropical Retreat",
  "Best Of Singapore | FREE Universal Studio Tickets Singapore & Malaysia Trip | FREE Night Safari Experience",
];

const toursForYou = [
  {
    title: "Best Selling UAE Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "International Tourist Visas",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Cruise Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Best Selling Singapore Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
];

const inclusiveTours = [
  {
    icon: <Accommodation />,
    title: "Accommodation",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <AllMeals />,
    title: "All meals",
    description: "Eat to your heart's content Breakfast. Lunch. Dinner.",
  },
  {
    icon: <OnTourTransport />,
    title: "On-tour transport",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <BestValueItinerary />,
    title: "Best value itinerary",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <TourManagers />,
    title: "Tour managers",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
];

const RibbonBadge = () => {
  return (
    <div class="ribbon">
      <span class="ribbon-text">3N / 4D</span>
    </div>
  );
};

const { Search } = Input;
const CruiseSearchPage = () => {
  return (
    <>
      <section>
        <CruiseSearch />
      </section>

      <section className="p-6 mt-8">
        <div className="container">
          {/* Header */}
          <Flex align="center" gap={10} className="mb-8">
            <Image src={cruiseIcon} />
            <div class="relative w-[60%]">
              {/* <!-- Stroke Layer --> */}
              <span class="absolute inset-0 text-[28px] leading-[36px] tracking-[6px] font-bold font-montserrat stroke-text-gray z-0">
                Cruise line deals
              </span>

              {/* <!-- Gradient Fill Layer --> */}
              <span class="relative text-[28px] leading-[36px] tracking-[6px] font-bold font-montserrat gradient-text z-10">
                Cruise line deals
              </span>
            </div>
          </Flex>

          {/* Cards */}
          <Row gutter={[16, 16]}>
            {offers.map((offer, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <Card
                  className="flex rounded-[20px] overflow-hidden border-[#E5E5E5]"
                  styles={{
                    body: {
                      padding: "0px",
                      flex: "1",
                    },
                  }}
                >
                  <div className="flex">
                    {/* Left image with half-oval */}
                    <div className="relative w-[45%] overflow-hidden rounded-r-full">
                      <div className="absolute overflow-hidden rounded-r-full bg-black/10 w-[95%] h-[100%] "></div>
                      <img
                        src={offer.img}
                        alt={offer.title}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Right content */}
                    <div className="w-[55%] p-5 pl-4 pr-2 flex flex-col justify-center">
                      <h3 className="text-base mb-2 font-medium">
                        {offer.title}
                      </h3>
                      <p className="text-xs mb-4 font-medium">{offer.desc}</p>
                      <small className="text-xs mb-1 font-medium">
                        {offer.note}
                      </small>
                      <Button
                        type="danger"
                        size="middle"
                        className="mt-2 text-xs rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] 
                        bg-danger hover:bg-red-700 border-none rounded-md px-4 py-2 text-white w-fit"
                      >
                        Search Cruises
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="p-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="font-normal text-primary">
                Top Cruise From <span className="text-danger">UAE</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[40, 16]}>
            {tours.map((tour, index) => (
              <Col xs={24} md={8} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <RibbonBadge />
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    <div className="font-bold text-primary text-xl leading-snug">
                      INR 1,43,200
                    </div>

                    <div className="text-lg mt-2 font-medium">
                      3 Nights Iconic Arabia with Celestyal
                    </div>

                    <Paragraph className="text-black/40 font-medium text-xs mt-2 leading-5">
                      Celestyal Discovery, operated by Celestyal Cruises, offers
                      an all-inclusive Mediterranean and Aegean cruise
                      experience with a focus on cultural immersion. 
                    </Paragraph>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="p-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="font-normal text-primary">
                Season’s Best <span className="text-danger">Cruise Picks</span>
              </h2>
              <Paragraph className="font-normal mt-1 mb-0">
                Culture, nature, thrills, and record-breaking experiences
              </Paragraph>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[16, 16]}>
            {cruisePack.map((tour, index) => (
              <Col xs={24} md={6} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <RibbonBadge />
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    <div className="font-bold text-primary text-xl leading-snug">
                      INR 1,43,200
                    </div>

                    <div className="text-lg mt-2 font-medium">
                      3 Nights Iconic Arabia with Celestyal
                    </div>

                    <Paragraph className="text-black/40 font-medium text-xs mt-2 leading-5">
                      Celestyal Discovery, operated by Celestyal Cruises, offers
                      an all-inclusive Mediterranean and Aegean cruise
                      experience with a focus on cultural immersion. 
                    </Paragraph>
                    <Paragraph className="text-primary text-sm font-medium !mb-0">
                      9 days & 8 nights
                    </Paragraph>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section className="p-6">
        <div className="container">
          {/* Title */}
          <div className="flex justify-between items-center mb-6">
            <div>
              <h2 className="font-normal text-primary">
                Embark on Your{" "}
                <span className="text-danger">Perfect Getaway</span>
              </h2>
              <p className="font-normal mt-1">
                Culture, nature, thrills, and record-breaking experiences
              </p>
            </div>
            <a href="#" className="font-normal text-xs">
              View More <DoubleRightOutlined />
            </a>
          </div>

          {/* Cards Row */}
          <Row gutter={[16, 16]}>
            {cruisePack.map((tour, index) => (
              <Col xs={24} md={6} key={index}>
                <div className="bg-white rounded-xl overflow-hidden relative shadow-custom hover:shadow-2xl">
                  {/* Image */}
                  <div className="relative">
                    <div className="absolute overflow-hidden bg-black/20 w-full h-[100%] ">
                      <RibbonBadge />
                    </div>
                    <img
                      src={tour.image}
                      alt="Tour"
                      className="w-full h-[203px] object-cover"
                    />
                    {/* Rating Badge */}
                    <div
                      className={`bg-primary absolute bottom-[-25px] right-6 rounded-full shadow-lg text-white text-sm flex  justify-center w-[80px] h-[80px] ${tour.badgeColor}`}
                    >
                      <div className="text-center leading-tight mt-2">
                        <div className="text-3xl">★</div>
                        <div className="text-xs font-normal">4.9 (523)</div>
                      </div>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-5 pt-3">
                    <div className="font-bold text-primary text-xl leading-snug">
                      INR 1,43,200
                    </div>

                    <div className="text-lg mt-2 font-medium">
                      3 Nights Iconic Arabia with Celestyal
                    </div>

                    <Paragraph className="text-black/40 font-medium text-xs mt-2 leading-5">
                      Celestyal Discovery, operated by Celestyal Cruises, offers
                      an all-inclusive Mediterranean and Aegean cruise
                      experience with a focus on cultural immersion. 
                    </Paragraph>
                    <Paragraph className="text-primary text-sm font-medium !mb-0">
                      9 days & 8 nights
                    </Paragraph>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {/* Banner Slider  */}
      <section className="p-6">
        <div className="container">
          <Carousel
            autoplay
            dots
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <div className="flex items-center">
              <div className="absolute z-10 inset-0 bg-[linear-gradient(90deg,_rgba(109,111,120,0.4)_0%,_#09090D_100%)] bg-blend-hard-light" />
              <Image
                src={sliderImg}
                alt="Slide 1"
                className="w-full !h-full object-cover"
                preview={false}
              />

              <Flex
                className="absolute z-20 inset-0 text-white px-12"
                align="center"
                justify="space-between"
              >
                <Flex flex={1} justify="space-between" className="" vertical>
                  <Flex justify="start" vertical align="start">
                    <Title
                      level={1}
                      className="!text-white rounded !font-medium !mb-0 !text-4xl"
                    >
                      Experience the Wow
                    </Title>

                    <Title
                      level={2}
                      className="!text-white uppercase rounded !text-5xl !mt-2 !mb-0"
                    >
                      in Every Stay
                    </Title>

                    {/* CTA Button */}
                    <Button
                      type="danger"
                      size="large"
                      className="font-medium text-xl bg-white mt-8 
                      border-none rounded-md px-16 py-8 text-[12273D] w-fit"
                    >
                      Book Now!
                    </Button>
                  </Flex>
                </Flex>

                <Flex
                  flex={1}
                  justify="center"
                  align="center"
                  className=""
                  vertical
                >
                  {/* Box Outline */}

                  <fieldset class="w-full mt-8 border-2 border-white border-solid rounded-[8px] p-6 text-white inline-block relative">
                    <legend class="px-4 w-auto text-xl font-semibold !mb-0 text-center">
                      STARTING PRISE
                    </legend>
                    {/* Diagonal Badge */}
                    <div className="absolute -top-5 -right-8 transform rotate-45 bg-blue-600 text-white text-lg font-bold px-3 py-[2px] shadow-md">
                      <Title
                        level={4}
                        className="!text-white !mb-0 !font-medium"
                      >
                        4N/5D
                      </Title>
                    </div>

                    {/* Price Text */}
                    <h1 className="large font-black leading-none text-center">
                      INR 35,999
                    </h1>
                    <p className="uppercase text-center text-xl font-semibold tracking-wide">
                      PER PERSON (BASED ON 2 PAX)
                    </p>
                  </fieldset>

                  <Flex
                    vertical
                    className="w-[60%] mx-auto"
                    justify="center"
                    align="center"
                  >
                    {/* Decorative Line */}
                    <div className="w-full h-[4px] bg-white rounded-full mt-10 mx-auto"></div>
                  </Flex>
                </Flex>
              </Flex>
            </div>
          </Carousel>
        </div>
      </section>

      <section className="py-6">
        <ExploreAttractions />
      </section>

    
      <section className="py-6">
        <ReviewSlider />
      </section>
      <section className="p-6">
        <ExplorePlaces />
      </section>
    </>
  );
};

export default CruiseSearchPage;
